export function e2eSentryTags(): Record<string, string> {
  if (typeof window === 'undefined' || !('__auroraE2E' in window)) return {}
  const marker: unknown = window.__auroraE2E
  if (typeof marker !== 'object' || marker === null || !('traffic_source' in marker) || marker.traffic_source !== 'e2e')
    return {}
  const tags: Record<string, string> = { traffic_source: 'e2e' }
  if ('e2e_suite' in marker && typeof marker.e2e_suite === 'string') tags.e2e_suite = marker.e2e_suite.slice(0, 200)
  if (
    'e2e_run_id' in marker &&
    typeof marker.e2e_run_id === 'string' &&
    /^[a-zA-Z0-9_-]{1,100}$/.exec(marker.e2e_run_id)?.[0] === marker.e2e_run_id
  )
    tags.e2e_run_id = marker.e2e_run_id
  if (
    'e2e_run_url' in marker &&
    typeof marker.e2e_run_url === 'string' &&
    /^https:\/\/github\.com\/sigholm\/aurora-e2e\/actions\/runs\/\d+\/attempts\/\d+$/.exec(marker.e2e_run_url)?.[0] ===
      marker.e2e_run_url
  )
    tags.e2e_run_url = marker.e2e_run_url
  return tags
}
